<template>
    <modal ref="modal" @close="markSeen">
        <template v-slot:title>Set up two-step verification</template>
        <slot>
            <p v-if="setup">From {{ deadline }}, you'll need two-step verification to sign in. It takes about 5 minutes.</p>
            <button-row>
                <button type="button" class="btn btn-link" data-test="mfa-prompt-later" @click.prevent="close">Remind me later</button>
                <button type="button" class="btn btn-primary" data-test="mfa-prompt-now" @click.prevent="setUpNow">Set up now</button>
            </button-row>
        </slot>
    </modal>
</template>

<script>
import ModalMixin from '@/mixins/ModalMixin'
import { formatDeadline } from '@/mfa-deadline'
import { isNativeHost } from '@/native-bridge'

// Once per browser session, before the deadline. Storage can be blocked
// (private windows), so a failed read just means it may show again.
const SEEN_KEY = 'gmps_mfa_prompt_seen'

function seenThisSession() {
    try {
        return window.sessionStorage.getItem(SEEN_KEY) === '1'
    } catch {
        return false
    }
}

export default {
    mixins: [ModalMixin],
    data() {
        return {
            native: isNativeHost(),
            opened: false,
        }
    },
    computed: {
        setup() {
            const user = this.$store.state.user
            const setup = user && user.mfa_setup
            return setup && !setup.enforced ? setup : null
        },
        deadline() {
            return formatDeadline(this.setup.deadline)
        },
        // the account page has the setup card already
        onSetupPage() {
            const name = (this.$route && this.$route.name) || ''
            return name === 'mfa-setup' || name.startsWith('account')
        },
        shouldOpen() {
            return Boolean(this.setup) && !this.native && !this.onSetupPage
        },
    },
    watch: {
        shouldOpen: {
            immediate: true,
            handler(value) {
                if (value && !this.opened && !seenThisSession()) {
                    this.opened = true
                    this.$nextTick(() => this.open())
                }
            },
        },
    },
    methods: {
        markSeen() {
            try {
                window.sessionStorage.setItem(SEEN_KEY, '1')
            } catch {
                // blocked storage: it shows again next time, which is fine
            }
        },
        setUpNow() {
            this.close()
            this.$router.push({name: 'account'})
        },
    },
}
</script>
